import * as Store from 'store';
import * as API from 'api'
import { User, Operation, Navigation } from 'application';
import { ROUTES } from 'config';
import { IAuthResult } from 'api/Auth0';
import { scrollToTop } from './navigation';

/** Check User Is Logged into application */
export const isAuthenticated = (state: Store.IRootState): boolean => {
    const expireAt = getAccessTokenExpiry(state);
    const token = getAccessToken(state);
    if (expireAt && token) {
        return new Date().getTime() < expireAt;
    }
    return false;
}

// dispatch wrapper response
export const authenticationActionHandler = (dispatch) => (result: IAuthResult) => {
    if (result) {
        dispatch(Store.Authentication.authenticationSuccess(result));
        if (result.metaInfo && result.metaInfo.ff_user_id) {
            // regular sign in 
            API.Analytics.loggedIn(result.metaInfo.ff_user_id);
        } else {
            // no meta data => a new sign up
            dispatch(Store.Authentication.signUpSuccess(result));
            const { email, created_at, identity_provider: authenticationType, firstName, lastName } = result.metaInfo;
            // when custom sign up form is used name come from form fields
            const name = (firstName || lastName) ? `${firstName} ${lastName}` : result.name;
            API.Analytics.signUpCompleted(authenticationType, { id: result.id, email, created_at, name });
        }
    }
    return result;
};

/** Handles authentication response & ensures store is updated and token is scheduled for renewal */
function handleAuthResult(dispatch, result: IAuthResult) {
    console.debug('Processing authentication result...')
    const handler = authenticationActionHandler(dispatch);
    API.Auth0.scheduleTokenRenewal(result.expiresAt, handler);
    handler(result);
}

/** Process authentication information from authentication callback hash  */
export const authenticate = (hash, dispatch) => {
    return API.Auth0.parseAuthenticationHash(hash)
        .then((result) => {
            handleAuthResult(dispatch, result);
            Navigation.redirectTo(dispatch, ROUTES.HOME);
        })
        .then(() => {
            User.loadUserInformation(dispatch);
        })
        .catch(err => {
            Operation.onFail('Failed to parse authentication information from Auth0', dispatch, err);
        })
}

/** Trigger renewal of Authentication Token(s) */
export const renewAccessToken = (dispatch) => {
    console.debug('Renewing token...')
    return API.Auth0.renewToken().then((authResult) => {
        console.debug('Token renewed.')
        handleAuthResult(dispatch, authResult)
        return authResult;
    }).catch(err => Operation.onFail('Failed to review access token', dispatch, err));
}

/** User Id  */
export const getUserId = ({ authentication }: Store.IRootState) => {
    return (authentication && authentication.id) ? authentication.id : null;
}

/** Authentication Access Token (Oauth)  */
export const getAccessToken = ({ authentication }: Store.IRootState) => {
    return (authentication && authentication.accessToken) ? authentication.accessToken : null;
}

/** Authentication Access Token (Oauth)  */
export const getAccessTokenExpiry = ({ authentication }: Store.IRootState) => {
    return (authentication && authentication.expiresAt) ? authentication.expiresAt : null;
}

/** Open Login Popup */
export const openLogin = (dispatch, ctaButtonText) => {
    //popup shows on top make sure user can see it
    scrollToTop();
    API.Auth0.openLogin().then(() => {
        API.Analytics.ctaButtonClicked(ctaButtonText);
        dispatch(Store.Authentication.loginStart())
    });
}

/** Open Sign Up Popup */
export const openSignUp = (dispatch, ctaButtonText) => {
    //popup shows on top make sure user can see it
    scrollToTop();
    API.Auth0.openSignUp().then(() => {
        API.Analytics.ctaButtonClicked(ctaButtonText);
        dispatch(Store.Authentication.signUpStart())
    });
}

/** Sing user out of application */
export const logout = (dispatch) => {
    API.Auth0.logout().then(() => {
        dispatch(Store.Authentication.logout());
        Navigation.redirectTo(dispatch, ROUTES.LANDING);
    });
}








// WEBPACK FOOTER //
// ./src/application/authentication.ts